module.exports = __webpack_public_path__ + "aeab626580c6dded7b7ac8b0c0679396.png";